module.exports = __webpack_public_path__ + "static/media/streak.6a6e408a.svg";